import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'

const Accelerate = () => {
    return (
        <>
            {/* Accelerate cloud */}
            <section className="accelerate-cloud-three mt-5">
                <div className="container">
                    {/* <div className="shapes-three-left">
                        <ImageWithBasePath
                            className="accelerate-three"
                            src="assets/img/shapes/shape-8.png"
                            alt="Img"
                        />
                        <ImageWithBasePath
                            className="accelerate-five"
                            src="assets/img/shapes/shape-9.png"
                            alt="Img"
                        />
                    </div> */}
                    {/* Award Winning */}
                    <div className="award-one">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/index-3/female-student-img.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-9.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/award.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>REGISTER</h4>
                                    <h2 className="text-warning my-4">
                                        Sign Up for Free
                                    </h2>
                                    <p className="text-white mb-4">
                                        Create your account in minutes and tell us your study goals—we’ll match you with programs that fit you best. Fast, easy, and completely free!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Award Winning */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>SEARCH</h4>
                                    <h2 className="text-skyblue my-4">
                                        Choose Your Program
                                    </h2>
                                    <p className="text-white mb-4">
                                       Explore 140,000+ programs by country, intake, tuition, and more—completely free. Let our powerful AI match you with personalized options to simplify your journey and save you time.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/index-3/join.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/index-3/banner-img-1.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>APPLY</h4>
                                    <h2 className="text-success my-4">
                                        Submit a Winning Application
                                    </h2>
                                    <p className="text-white mb-4">
                                        Our rigorous quality checks make sure every document is in place—so you apply with confidence and stand out from the start.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>FUNDING</h4>
                                    <h2 className="text-skyblue my-4">
                                        Funding Your Future
                                    </h2>
                                    <p className="text-white mb-4">
                                       Boost your study permit application with a Guaranteed Investment Certificate (GIC), or secure the financial support you need through trusted student loan options.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/index-3/joing-us-skill.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/index-3/male-student-img.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>PAYMENT</h4>
                                    <h2 className="text-success my-4">
                                        Payments Made Simple
                                    </h2>
                                    <p className="text-white mb-4">
                                        Pay tuition securely with Flywire or transfer funds internationally with ease using Reeudo—fast, safe, and stress-free.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                     {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>VISA</h4>
                                    <h2 className="text-skyblue my-4">
                                        Request Visa Support
                                    </h2>
                                    <p className="text-white mb-4">
                                       Get expert guidance for your visa application through our trusted partner, OneVasco—ensuring a smoother, stress-free approval process.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 w-300 h-400"
                                        src="assets/img/index-3/banner-img-5.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                </div>
            </section>
            {/* Accelerate cloud */}
        </>

    )
}

export default Accelerate
